import getEnv from '@clearscore/helpers.envs';

export const CS_SESSION_COOKIE = getEnv('SESSION_COOKIE') || 'CS_SESSION';
export const CS_PERSON_COOKIE = 'CS_PERSON';
export const CS_PUBLISHER_ID = 'CS_PUBLISHER_ID';
export const VISITED_SITE_COOKIE_NAME = 'CS_VISITED_SITE';
